import { Header, HeaderWrapper } from './styled'

export const PageHeader = ({
  title,
  imageRatio,
  imageUrl,
}: {
  title: string
  imageRatio: string
  imageUrl: string
}) => (
  <HeaderWrapper>
    <Header ratio={imageRatio} imageUrl={imageUrl}>
      <h1>{title}</h1>
    </Header>
  </HeaderWrapper>
)
